<template>
  <div>
    <h1 class="text-2xl font-bold mb-6"><a href="/tokens"> Tokens </a> / Criar token</h1>
      <div class="container" v-if="!criado">
        <p>
          Forneça um nome para seu token de acesso, e quando criado,
          certifique-se de copiá-lo, pois ele só será exibido neste momento.
        </p>
        <p>
          Lembre-se que o token deve ser tratado como uma senha e armazenado com segurança
          por se tratar de uma informação sensível.
        </p>
        <form id="form-token" v-on:submit.prevent="onSubmit">
          <div class="form-box form-creditos">
            <label class="label">NOME</label>
            <input
              class="field name-w"
              maxlength="40"
              type="text"
              name="nome"
              required="required"
              v-model="form.nome"
              @keydown="form.errors.data = ''"
              autocomplete="off"
            />

            <fieldset class="mt" id="escopo">
              <legend>Este token também pode ser utilizado no
                <a href="https://api.escavador.com/playground" target="_blank">Playground</a>?
              </legend>
              <div>
                <div class="escopo-checkbox">
                  <input type="radio" id="incluir_playground" name="incluir_playground"
                         :value="false" v-model="form.acessarPlayground" :checked="!form.acessarPlayground">
                  <label for="incluir_playground"  class="font-medium text-sm">Não</label>
                </div>

                <div class="escopo-checkbox">
                  <input type="radio"  id="nao_incluir_playground" name="nao_incluir_playground"
                         :value="true" v-model="form.acessarPlayground" :checked="form.acessarPlayground">
                  <label for="nao_incluir_playground"  class="font-medium text-sm">Sim</label>
                </div>
              </div>
            </fieldset>

            <button :disabled="submited" type="submit" class="btn display-btn">
              <b>Criar Token</b>
            </button>
          </div>
          <span class="Message -fail" v-text="this.form.errors.data"></span>
        </form>
      </div>
      <div class="container" slot="content" v-if="criado">
        <form v-on:submit.prevent="concluir">
          <div class="form-box form-creditos">
            <label class="label" for="nome">Nome</label>
            <input
              class="name-field"
              id="nome"
              type="text"
              v-model="this.form.nome"
              readonly
            />
          </div>

          <button class="btn -right">
            <b>Concluir</b>
          </button>
          <button class="btn -right" @click.prevent="copiarToken">
            <b>Copiar Token</b>
          </button>

          <div class="form-box form-creditos">
            <label class="label" for="token">Token</label>
            <textarea
              rows="13"
              id="token"
              v-model="this.token"
              readonly
              class="token-field"
            ></textarea>
            <p class="heading -likeH5  v--text-secondary mt">
              Certifique-se de salvar o token. Você não poderá acessá-lo novamente.
            </p>
          </div>
        </form>
      </div>
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from "../monitoramentos/Loading";
import { getUrlParams } from "../../admin/utils";

export default {
  name: "criar-token",
  data() {
    return {
      criado: false,
      form: new Form({
        nome: "",
        acessarPlayground: false,
      }),
      token: "",
      closeButton: false,
      submited:false,
    };
  },
  components: {
    Loading
  },
  created() {
    let params = getUrlParams()

    if (Object.keys(params).length && +params['playground']) {
       this.form.acessarPlayground = true;
    }
  },
  methods: {
    escopos() {
      let escopos = ['acessar_api_paga'];

      if (this.form.acessarPlayground) {
        escopos.push('acessar_api_playground')
      }

      return escopos;
    },
    onSubmit: function() {
      EventBus.$emit('loading-show');

      this.submited = true;
      axios({
        method: "post",
        url: "/api/v1/criar-token",
        data: {
          nome: this.form.nome,
          escopos: this.escopos()
        }
      })
        .then(response => {
          this.token = response.data.access_token;
          this.closeButton = true;
          this.criado = true;
          EventBus.$emit('loading-hide');
        })
        .catch((error) => {
          this.submited = false;

          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    copiarToken: function() {
      let token = document.querySelector("#token");

      token.select();

      document.execCommand("copy");

      window.getSelection().removeAllRanges();

      EventBus.$emit("loading-hide");
      this.$store.dispatch("showLoadingMessage", {
        message: "Token Copiado!",
        type: "done"
      });
    },
    concluir() {
      const path = this.form.acessarPlayground ? "/playground" : "/tokens";
      window.location.replace(path);
    }
  }
};
</script>
<style lang="stylus">
.mt
  margin-top 24px
.display-btn
  width 115px
.name-w
  width: 80%
.token-field
  resize none
.name-field
  width 50%
.mb-0
  margin-bottom 0 !important
input[type="checkbox"], input[type="radio"]
  max-width 20px
  max-height 20px
.escopo-checkbox
  display flex
  align-items center
  flex-direction row
  gap 12px
#escopo a
  color royalblue
</style>
